import React,{useState,useEffect} from "react";
import API from "../../../utils/API";
import {Link, useHistory} from "react-router-dom";
import {Breadcrumb, BreadcrumbItem, Card, CardBody, Col, Container, Row, Table} from "reactstrap";
import Loader from "../../../components/Loader";
import dateFormat from "dateformat";
import DateRange from "../../../components/formfields/DateRange";
import ListStat from "../../../components/ListStat";
import Datetime from "../../../components/fields/Datetime";
import Pagination from "../../../components/Pagination";
import Lender from "../../../components/fields/Lender";

const RevenueUploadLog = (props) => {

    const defaultDate = dateFormat((new Date()).setDate((new Date()).getDate() - 180),"mmm d, yyyy")+" to "+dateFormat(new Date(),"mmm d, yyyy")

    const [filtration,setFiltration] = useState({page:1,perPage:50,date:defaultDate})
    const [log, setLog] = useState(null)
    const [loading, setLoading] = useState(true)
    const [data,setData] = useState(null)

    const changeData = (name,value) => {
        setFiltration({ ...filtration, [name]: value })
    }

    useEffect(() => {
        setLoading(true)
        API.post('/tools/revenueupload/log',filtration).then((response) => {
            setLog(response.data.data.data)
            setData(response.data.data)
            setLoading(false)
        });
    }, [filtration])

    let history = useHistory()

    return <Container fluid className="p-0">
        <Breadcrumb>
            <BreadcrumbItem>
                <Link to="/tools/revenueupload">Revenue upload</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>Revenue upload log</BreadcrumbItem>
        </Breadcrumb>
        <Row form>
            <Col md={4}>
                <div className="row ml-2">
                    <div className="col-auto pt-1">
                        <label>Date range</label>
                    </div>
                    <div className="col">
                        <DateRange
                            onChange={changeData}
                            name={'date'}
                            value={defaultDate}
                        />
                    </div>
                </div>
            </Col>
        </Row>
        <Card className="mt-2">
            {loading &&
                <Loader absolute={true}/>
            }
            {log?.length > 0 ?
                <div className="table-responsive">
                    <ListStat data={data}/>
                    <Table>
                        <thead>
                        <tr>
                            <th>Id</th>
                            <th>Date</th>
                            <th>Lender</th>
                            <th>User</th>
                            <th>Detail log</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            log.map((logItem, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{logItem.id}</td>
                                        <td><Datetime dateTime={logItem.dateadd}/></td>
                                        <td className="text-dark"><Lender lender={logItem.lender}/></td>
                                        <td>{logItem.user.name}</td>
                                        <td><Link to={`/tools/revenueupload/logitem/${logItem.id}`}>Log</Link></td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </Table>
                </div>
                :
                !loading &&
                <CardBody className="text-center"><h5>Data not found</h5></CardBody>
            }
        </Card>
        {(data?.page > 0 && data?.pages > 0) &&
            <Pagination
                onChange={changeData}
                name={"page"}
                page={data.page}
                totalPages={data.pages}/>
        }
    </Container>
}

export default RevenueUploadLog
